import DocTypeService from "@/service/DocTypeService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { DocType } from "@/model/DocType";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import docTypeValidationObj from "./S081100-DocTypeValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var docTypeDataValidationObj = new docTypeValidationObj();
export default {
  name: "docType",
  mounted() {
    docTypeDataValidationObj.docTypeValidation();
    this.assignRights();
    this.resetDocTypeData();
    this.init();
    this.getAllDocType();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_DocumentType,
    Settings: Settings, 
    dictEnum: dictEnum,
    docType: new DocType(),
    isEditMode: false,
    docTypeList: [],
    selectAllDocType: false,
    tempDocTypeModel: new DocType(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".docType-table table thead").height();
      var pagginationHeight = $(".paggination-docType").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllDocType() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await DocTypeService.getAllDocTypesByPagination(obj);
      if (response.data.IsSuccess) {
        self.docTypeList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDocTypeDetail() {
      var self = this;
      const obj = {
        docTypeCode: self.tempDocTypeModel.DocTypeCode,
      };
      const response = await DocTypeService.getDocTypeDetailByDocTypeCode(obj);
      if (response.data.IsSuccess) {
        self.docType = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllDocTypeRecord: function () {
      var self = this;
      var IsSelected = self.selectAllDocType;
      self.docTypeList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleDocTypePopup: function () {
      var arrayList = [];
      var self = this;
      self.docTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteDocTypeModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleDocType() {
      var arrayList = [];
      var self = this;
      $('#deleteDocTypeModel').modal('hide');
      self.docTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        docTypeList: arrayList,
      };
      const response = await DocTypeService.deleteDocType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTypeData();
        self.init();
        await self.getAllDocType();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnDocTypSelect: function (model) {
      this.tempDocTypeModel = model;
    },
    addDocType: function () {
      var self = this;
      $('#docTypeModel').modal('show');
      self.isEditMode = false;
      self.docType = new DocType();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveDocTypeData(obj) {
      var self = this;
      const response = await DocTypeService.addDocType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTypeData();
        self.init();
        await self.getAllDocType();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditDocTypeData(obj) {
      var self = this;
      const response = await DocTypeService.updateDocType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDocTypeData();
        self.init();
        await self.getAllDocType();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveDocType() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#docTypeModel').modal('hide');
          const obj = {
            model: {
              DocTypeCode: self.docType.DocTypeCode,
              CDesc: self.docType.CDesc,
              EDesc: self.docType.EDesc
            }
          };
          if (self.isEditMode) {
            self.EditDocTypeData(obj);
          }
          else {
            self.saveDocTypeData(obj);
          }
        }
      });
    },
    async editDocType() {
      var self = this;
      self.isEditMode = true;
      if (self.tempDocTypeModel.DocTypeCode != "") {
        await self.getDocTypeDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#docTypeModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetDocTypeData: function () {
      var self = this;
      self.selectAllDocType = false;
      self.isEditMode = false;
      self.docType = new DocType();
      self.tempDocTypeModel = new DocType();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeDocTypePopup: function () {
      var self = this;
      self.selectAllDocType = false;
      self.isEditMode = false;
      self.docType = new DocType();
      self.tempDocTypeModel = new DocType();
      self.$validator.reset();
      self.vErrors.clear();
      $('#docTypeModel').modal('hide');
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllDocType();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081100-DocType/S081100-DocType.js